import { JobTitle } from '@connect-x-app/shared-domain-models';
import { UserUtil } from '@connect-x-app/shared-utils';
import { ReceiverOptions } from '@connect-x-app/shared-view-models';

import { determineSystemMessageReceiver } from './determineSystemMessageReceiver.util';

interface RecipientsCellValue {
  isBold: boolean;
  value: string;
}

const getTranslatedRecipients = (recipients: JobTitle[]) =>
  recipients.map(recipient => {
    const divisionName = UserUtil.getDivision(recipient);
    return divisionName || recipient;
  });

export const getRecipientsCellValue = (
  recipients: JobTitle[] | undefined | null,
  allFunctionsTranslation: string,
): RecipientsCellValue => {
  const receiverOption = determineSystemMessageReceiver(recipients);

  switch (receiverOption) {
    case ReceiverOptions.ALL_FUNCTIONS:
      return { isBold: true, value: allFunctionsTranslation };

    case ReceiverOptions.SPECIFIC_FUNCTIONS:
      return { isBold: false, value: getTranslatedRecipients(recipients ?? []).join(', ') };

    case ReceiverOptions.NO_FUNCTIONS:
      return { isBold: false, value: '-' };

    default:
      return { isBold: false, value: '-' };
  }
};
